import { takeEvery } from 'redux-saga/effects';
import { ADMIN_FETCH_POLICIES, ADMIN_UPDATE_POLICIES } from './actions';
import { fetchPoliciesEffect, updatePoliciesEffect } from './effects';

export const adminSaga = function* () {
  yield takeEvery(ADMIN_FETCH_POLICIES, fetchPoliciesEffect);
  yield takeEvery(ADMIN_UPDATE_POLICIES, updatePoliciesEffect);
};
